<template>
    <WindowLayout :title="title">
        <div class="row">
            <div class="col-sm-12">
                <div class="darmin card">
                    <div class="card-header pb-0 d-flex align-items-center">
                        <h5>{{ headerTitle }}</h5>
                    </div>
                    <div class="card-body theme-form">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Topic</label>
                                    <div class="col-md-9">
                                        <select class="form-select" v-model="form.state.topic">
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="topic in topics" :key="topic" :value="topic.codigo">{{ topic.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Usuario</label>
                                    <div class="col-md-9">
                                        <select class="form-select" v-model="form.state.user">
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="user in users" :key="user" :value="user.id">{{ user.fullName }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Estado</label>
                                    <div class="col-md-9">
                                        <SelectInputSimpleState
                                            v-model="form.state.status"
                                        ></SelectInputSimpleState>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-12 text-end">
                                <div
                                    v-if="!props.item"
                                    class="btn btn-primary ms-auto"
                                    @click="handleAction('create')"
                                >
                                    <i class="far fa-save"></i>
                                    Guardar
                                </div>
                                <div
                                    v-else
                                    class="btn btn-primary ms-auto"
                                    @click="handleAction('update')"
                                >
                                    Actualizar
                                </div>
                                <div
                                    v-if="props.item && form.state.status === 1"
                                    class="btn btn-danger ms-2"
                                    @click="handleAction('delete')"
                                >
                                    Eliminar
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </WindowLayout>
</template>

<script setup>
// eslint-disable-next-line object-curly-newline
import { defineProps, onMounted } from 'vue';

import WindowLayout from '@/layouts/Window.layout.vue';
import SelectInputSimpleState from '@/components/form/SelectInputSimpleState.vue';

import { useSnackbar } from 'vue3-snackbar';

import useSubscriptions from './services/useSubscriptions';
import useTopics from './services/useTopics';
import useUsers from '../Users/services/useUser';
import { useSubscriptionsForm } from './composables/useSubscriptionsForm';

const props = defineProps({
    title: { type: String, default: 'Subcripciones' },
    headerTitle: { type: String, default: 'Subscripción' },
    urlRead: { type: String, required: false },
    urlCreate: { type: String, required: false },
    urlUpdate: { type: String, required: false },
    item: Object,
});

const snackbar = useSnackbar();

const service = useSubscriptions();
const { topics, getTopics } = useTopics();
const { users, getUsers } = useUsers();
const { ...form } = useSubscriptionsForm();

onMounted(async () => {
    if (props.item) {
        await Promise.all([service.getSubscription(props.item.id)]);
        if (service.subscription) {
            form.setState(service.subscription.value);
        }
    }
    await getTopics();
    await getUsers();
});

const handleAction = async (action) => {
    await form.$v.value.$validate();
    if (!form.$v.value.$error) {
        switch (action) {
            case 'create':
                await service
                    .createSubscription({
                        topic: form.state.topic,
                        user: form.state.user,
                    })
                    .then(() => {
                        snackbar.add({
                            type: 'success',
                            text: 'Subscripción creada correctamente',
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        error.data.errors.map((e) => {
                            snackbar.add({
                                type: 'error',
                                text: e.msg,
                            });
                            return false;
                        });
                    });
                break;

            case 'update':
                await service
                    .updateSubscription(form.state.id, {
                        topic: form.state.topic,
                        user: form.state.user,
                        status: form.state.status,
                    })
                    .then(() => {
                        snackbar.add({
                            type: 'success',
                            text: 'Subscripción actualizada correctamente',
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        error.data.errors.map((e) => {
                            snackbar.add({
                                type: 'error',
                                text: e.msg,
                            });
                            return false;
                        });
                    });
                break;

            case 'delete':
                await service
                    .deleteSubscription(form.state.id)
                    .then(() => {
                        snackbar.add({
                            type: 'success',
                            text: 'Subscripción eliminada correctamente',
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        error.data.errors.map((e) => {
                            snackbar.add({
                                type: 'error',
                                text: e.msg,
                            });
                            return false;
                        });
                    });
                break;

            default:
                break;
        }
    } else {
        console.log(form.$v.value.$errors);
    }
    return true;
};
</script>
